import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import {Tooltip} from "@material-ui/core";
import SearchValuePopup from "./SearchValuePopup";
import CreateValuePopup from "./CreateValuePopup";
import findByString from "../../Utils/getValueByString";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../Components/JsonScreen/Utils/lib";
import {checkEvents} from "../../Utils/checkEvents";

const useStyles = makeStyles(() => ({
    container: {
        display: 'block'
    },
    labelContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    fieldLabel: {
        flex: 'none',
        display: 'block',
    },
    divider: {
        margin: '5px 0'
    }
}));

const EntityMixed = (props) => {
    const classes = useStyles();
    const {
        field, events = [], fieldStyles, labelStyles,
        errors, values, globalValues,
        doActions, showLabel, setValue, goBack,
        history, containerArrayPath, isMobile, insertValue
    } = props;

    const [searchIsOpen, setSearchIsOpen] = useState(false);
    const [fieldEvents, setFieldEvents] = useState({});
    const [createNewOpen, setCreateNewOpen] = useState({open: false, pathToUpdate: null, pathToInsert: null});
    useEffect(() => {
        const currentEvents = checkEvents(events);
        setFieldEvents(currentEvents);
    }, [JSON.stringify(events)]);

    function onApplySearchedValue(value) {
        const currentValue = findByString(globalValues, field.path) || [];
        let currentPath = field.path;
        if (field.isArray) {
            currentPath = containerArrayPath ? `${containerArrayPath}.${currentValue ? currentValue.length : 0}` :
                `${field.path}.${currentValue ? currentValue.length : 0}`
        }
        if (fieldEvents.onChange) {
            doActions(fieldEvents.onChange, {currentField: {value: value}})
        }
        setValue(value, currentPath);
        setSearchIsOpen(false)
    }

    function onApplyCreateNew() {
        const currentValue = findByString(globalValues, field.path) || [];
        let currentPath = createNewOpen.pathToUpdate ? createNewOpen.pathToUpdate : field.path;
        if (field.isArray) {
            currentPath = createNewOpen.pathToUpdate ? createNewOpen.pathToUpdate : `${field.path}.${currentValue.length || 0}`
        }
        createNewOpen.pathToInsert ?
            insertValue(createNewOpen.pathToInsert.path, createNewOpen.pathToInsert.index, globalValues.entityMixedCreation) :
            setValue(globalValues.entityMixedCreation, currentPath);
        setTimeout(() => {
            setValue(null, 'entityMixedCreation');
        }, 500);
        setCreateNewOpen(false);
        setSearchIsOpen(false)
    }

    function onClickSearch() {
        setSearchIsOpen(true)
    }

    function onClickCreateNew() {
        setCreateNewOpen({open: true, pathToUpdate: null})
    }

    function onClickEditRecord(props) {
        const currentValue = findByString(globalValues, props.currentItemPath);
        let currentPath = field.path;
        if (field.isArray) {
            currentPath = `${field.path}.${props.actionIndex}`
        }
        setValue(currentValue, `entityMixedCreation`);
        setCreateNewOpen({open: true, pathToUpdate: currentPath});
    }

    function onClickAddRecord(path, index) {
        setCreateNewOpen({
            open: true,
            pathToInsert: {path: field.path, index}
        })
    }

    return (
        <div className={classes.container}>
            <Label
                field={field}
                labelStyles={labelStyles}
                onClickSearch={onClickSearch}
            />
            <SearchValuePopup
                onClose={() => setSearchIsOpen(false)}
                open={searchIsOpen}
                onApply={onApplySearchedValue}
                globalValues={globalValues}
                field={field}
                onCreateNew={onClickCreateNew}
            />
            <CreateValuePopup
                field={field}
                onApply={onApplyCreateNew}
                children={field.children}
                open={createNewOpen.open}
                onClose={() => setCreateNewOpen(false)}
            />
        </div>
    )
};

export default EntityMixed

EntityMixed.propTypes = {
    errors: PropTypes.array,
    field: PropTypes.shape({
        label: PropTypes.string,
        path: PropTypes.string,
        autofocus: PropTypes.bool,
        isArray: PropTypes.bool,
        required: PropTypes.bool,
        entity: PropTypes.string,
        children: PropTypes.array
    }),
    globalValues: PropTypes.object,
    setValue: PropTypes.func
};

EntityMixed.defaultProps = {
    field: {
        children: []
    }
};

const Label = ({field, labelStyles, onClickSearch}) => {
    const classes = useStyles();
    const userLanguage = useSelector(state => state.app.userLanguage);
    return (
        <div className={classes.labelContainer}>
            <label className={classes.fieldLabel} style={{margin: labelStyles.margin}}>
                {multiLanguageValue(field.label, userLanguage)} {field.required &&
                <span style={{color: 'red'}}>*</span>}
            </label>
            <Tooltip title={'Search for value'}>
                <IconButton size={"small"} style={{marginLeft: 5}} onClick={onClickSearch}>
                    <Icon fontSize={"default"}>
                        manage_search
                    </Icon>
                </IconButton>
            </Tooltip>
        </div>
    )
};